import { ArrowRightOutlined } from '@ant-design/icons';
import { Button, Typography } from 'antd'
import React from 'react'
import { Translation } from 'react-i18next'
import browserHistory from '../browserHistory'
import { createStyleMap } from './compose'
import { ReactComponent as KnAnchor } from './logos/kn_anchor.svg'
import { ReactComponent as KnLetters } from './logos/kn_letters.svg'

const { Title } = Typography

interface IErrorBoundary {
  hasError: boolean
}

const styles = createStyleMap({
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '24px',
  },
  logoLetters: {
    width: '200px',
    marginRight: '10px',
  },
  logoAnchor: {
    width: '40px',
  },
  resetPadding: { padding: 0 },
})

class ErrorBoundary extends React.Component<{[key: string]: any}, IErrorBoundary> {
  state = {
    hasError: false,
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({
      hasError: true,
    })
  }

  handleUpdatePage = () => {
    this.setState({
      hasError: false,
    })
    // Reload the page
    browserHistory.go(0)
  }

  render() {
    return this.state.hasError ? (
      <section className={'boundary-container'}>
        <Translation>
          {t => (
            <div className={'boundary-block'}>
              <div style={styles.logoContainer}>
                <KnLetters style={styles.logoLetters} />
                <KnAnchor style={styles.logoAnchor} />
              </div>
              <Title level={2}>{t('boundary_error_title')}</Title>
              <p>{t('boundary_error_body_1')}</p>
              <p>{t('boundary_error_body_2')}</p>
              <Button
                type={'link'}
                icon={<ArrowRightOutlined />}
                style={styles.resetPadding}
                onClick={this.handleUpdatePage}>
                {t('boundary_action_button')}
              </Button>
            </div>
          )}
        </Translation>
      </section>
    ) : (
      this.props.children
    )
  }
}

export default ErrorBoundary
